<template>
  <v-form
    ref="form"
    v-model="valid"
    validate-on="lazy input"
    @submit.prevent
    data-testid="admin-email-form"
  >
    <div class="info-block pa-4 d-flex align-center mb-4" data-testid="warning-block">
      <v-icon class="mr-2" icon="$warning" data-testid="warning-icon" />
      <span
        class="body2"
        v-html="$t(`modals.addAdminEmailAddress.warningTitle`)"
        data-testid="warning-text"
      />
    </div>

    <v-combobox
      v-model="localValue"
      :label="$t(`modals.addAdminEmailAddress.adminEmailLabel`)"
      :aria-label="$t(`modals.addAdminEmailAddress.adminEmailLabel`)"
      :rules="[required(), emailRule()]"
      variant="outlined"
      data-testid="admin-email-input"
    />
  </v-form>
</template>

<script lang="ts">
import { defineComponent, ref, watch, type PropType } from "vue";
import type { BlockedEmailReportUser } from "@/_store/email-security/email-settings.module";
import { required, emailRule } from "@/_helpers/validators";
import type { DialogDataConfig } from "@/_store/dialogs.module";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig<BlockedEmailReportUser | null>>,
      required: true,
    },
  },
  emits: ["update:valid", "update:localValue"],
  setup(props, { emit }) {
    const form = ref();
    const valid = ref<boolean | null>(false);
    const localValue = ref<string>(props.config.item?.email ?? "");

    const validate = async () => {
      const { valid } = await form.value.validate();
      return valid;
    };

    watch(
      localValue,
      (newVal) => {
        emit("update:localValue", { email: newVal, userId: "" } as BlockedEmailReportUser);
      },
      { immediate: true }
    );

    watch(valid, (newValid) => {
      if (newValid === null) {
        return;
      }
      emit("update:valid", newValid);
    });

    return {
      form,
      valid,
      localValue,
      validate,
      required,
      emailRule,
    };
  },
});
</script>
